<template>
  <div
    class="insurance-external-redirect"
    data-qa="insurance-external-redirect"
  >
    <h2
      v-if="header"
      class="insurance-external-redirect__header"
      v-html="header"
    />
    <div
      v-if="description"
      class="insurance-external-redirect__description"
      v-html="description"
    />

    <div class="insurance-external-redirect__cta">
      <BaseButton
        v-if="ctaView === 'outlined'"
        variant="outlined"
        size="small"
        :text="ctaText"
        @click="handleClickEvent"
      />
      <BaseButton
        v-else
        :text="ctaText"
        @click="handleClickEvent"
      />
    </div>
  </div>
</template>

<script setup>
import openExternalUrl from '@shared/helpers/openExternalUrl'
import { useI18n } from 'petite-vue-i18n'

import BaseButton from '@shared/components/BaseButton.vue'
import { computed } from 'vue'

const { t } = useI18n()

const props = defineProps({
  header: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  cta: {
    type: String,
    default: '',
  },
  ctaView: {
    type: String,
    default: 'midnight',
  },
})

const emit = defineEmits(['click'])

const ctaText = computed(
  () => props.cta || t('eu__insurance_external_redirect__cta_v9.1.0'),
)

const handleClickEvent = (event) => emit('click', event)

const openUrl = (url) => openExternalUrl(url)

defineExpose({ openUrl })
</script>

<style lang="scss">
.insurance-external-redirect {
  background-color: $kds-color-background-base;

  &__header {
    color: $kds-color-text-primary;
    margin: 0;
    padding: 0;

    @include kds-typography-title-xlarge;
  }

  &__description {
    color: $kds-color-text-secondary;
    margin: 8px 0 16px;
    padding: 0;

    @include kds-typography-paragraph-large;
  }
}
</style>
